import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import storage from '@/utils/storage'
import { toast } from 'react-toastify'
class AuthService {
  static resource = API_RESOURCE.AUTH

  static loginWithSiemensID = async (body) => {
    const { status, data } = await axios.post(`${this.resource}/siemensid/token`, body)
    console.log(data)
    if (status === 200 && data.data) {
      toast.success('Login With Siemens ID Success')
      storage.setToken(data.data)
      setTimeout(() => {
        window.location.reload()
      }, 100)
    } else {
      throw new Error('Error In Login')
    }
    return data
  }

  static requestPasswordReset = async ({ email }) => {
    const response = await axios.put(`${this.resource}/requestPasswordReset`, { email })
    return response.data
  }

  static resetPassword = async ({ password, userId, token }) => {
    const response = await axios.put(`${this.resource}/resetPassword`, { password, userId, token })
    return response.data
  }

  static verifyRecaptcha = async ({ captchaValue }) => {
    const response = await axios.post(`${this.resource}/reCaptchaVerify`, { captchaValue })
    return response.data
  }

  static loginWithEmailAndPassword = async (payload) => {
    const { status, data } = await axios.post(`${this.resource}/email`, payload)
    if (status === 200 && data?.token) {
      storage.setToken(data?.token)
    } else {
      throw new Error('Error In Login')
    }
    return data
  }
}

export default AuthService
